export default "__VITE_ASSET__12ce450f__"